// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackBeginCheckoutParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackBeginCheckout";
import { PartialSpecific } from "@toolkit/Framework/Types/Common";

const useTrackBeginCheckout = (
    parameters: PartialSpecific<TrackBeginCheckoutParameters, "items"> = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    const hookParameters: TrackBeginCheckoutParameters = {
        ...ga.use.eventListParameters(options),
        ...parameters,
    };

    const hookOptions: Toolkit.GoogleAnalytics.Options = {
        promotions: ga.use.promotions(options),
        cart: ga.use.cart(options, true),
        ...options,
    };

    return (parameters: Partial<TrackBeginCheckoutParameters> = {}, options?: Toolkit.GoogleAnalytics.Options) => {
        return ga.track.beginCheckout({ ...hookParameters, ...parameters }, { ...hookOptions, ...options });
    };
};

export default useTrackBeginCheckout;
